import type { AdminReviewListInput } from '@repo/api-contracts';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';

/**
 * 관리자 후기 목록(reviewManagement.list) — 쪽·상품·별점·상태·사진 필터. 조건을 바꾸는 동안 이전 쪽 표를
 * 자리표시자로 유지한다(주문 목록과 같다).
 */
export const useReviewsListQuery = (input: AdminReviewListInput) =>
  trpc.reviewManagement.list.useQuery(input, { placeholderData: keepPreviousData });
